<script>
  import { onMount } from "svelte"
  import {load,save} from "../shared/api.js"
  import {session, countries} from "./account-store.js"
  import Button from "../shared/button.svelte"
  import { slide } from 'svelte/transition';
  import Userform from './userform.svelte'

  let loading = false
  let saving = false
  let saved = false
  let data = $session
  session.load()
  countries.load()

  async function saveUser(data){
    saving = true
    data = (await save({url:"/duocms/api/users/me",data,method:"PUT"})).data
    saved = true
    setTimeout((()=> saved=false),4000)
    saving = false
  }
</script>

<style>
  .userdetails-toolbar{
    display:flex;
    justify-content:flex-end;
    margin:5px 0;
  }
</style>

<div class="wrapper">
    <Userform bind:user={$session} disabled={!$session.id} />
    {#if saved}
      <div class="alert alert-success" transition:slide>
        Your details have been saved successfully
      </div>
    {/if}
    <div class="userdetails-toolbar">
      <Button mode="primary" disabled={saving} on:click={(e)=> saveUser($session)}>Save</Button>
    </div>
</div>